/**
 * description:
 * dateTime: 2024/8/21-下午4:01
 * author: ZhangJun 1580043700@qq.com
 */
import styles from '@/pages/config/content/edit/index.module.less'
import { SBack, SGeneralForms } from 'shj-components'
import { Avatar, Flex, Form, Spin, Tabs, Tag } from 'antd'
import { IConfig } from 'shj-components/dist/es/SGeneralForms/type'
import { Growth, Integral } from '@/pages/config/member/user/details/table.tsx'
import { useRequest } from 'ahooks'
import { queryMemberInfo } from '@/services/member.ts'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { UserOutlined } from '@ant-design/icons'

function Details() {
  const [searchParams] = useSearchParams()
  const detailId = searchParams.get('id')
  const [form] = Form.useForm()

  const {
    loading: loadingDetails,
    runAsync: runDetails,
    data: details,
  } = useRequest(queryMemberInfo, { manual: true })

  useEffect(() => {
    runDetails({ id: detailId }).then(data => {
      const result: any = data || {}
      form.setFieldsValue({
        ...result,
        jValue: result?.integralDeatil?.currentValue,
        cValue: result?.rowthValueDeatil?.currentValue,
      })
    })
  }, [detailId])
  const goBack = () => {
    history.back()
  }

  const configs: Array<IConfig> = [
    {
      title: '',
      formItem: [
        {
          label: '会员ID',
          name: 'id',
          children: () => (
            <Flex>
              <Tag>{details?.['id']}</Tag>
            </Flex>
          ),
        },
        {
          label: '会员昵称',
          name: 'name',
        },
        {
          label: '会员积分',
          name: 'integralValue',
        },
        {
          label: '会员成长值',
          name: 'growValue',
        },
        {
          label: '生日',
          name: 'birthDay',
        },
        {
          label: '会员等级',
          name: 'levelName',
          children: () => (
            <Flex>
              <Tag color="magenta">{details?.['levelName']}</Tag>
            </Flex>
          ),
        },
        {
          label: '最近访问时间',
          name: 'lastLoginTime',
        },
        {
          label: '注册时间',
          name: 'createdTime',
        },
      ],
    },
  ]

  const items = [
    {
      label: '积分流水',
      key: '1',
      children: <Integral memberId={detailId} />,
    },
    {
      label: '成长值流水',
      key: '2',
      children: <Growth memberId={detailId} />,
    },
  ]

  return (
    <SBack title="基本信息" level={2} goPath={goBack}>
      <div className={styles.container}>
        <div className={styles.title_wrap}>
          <Spin spinning={loadingDetails}>
            <Flex style={{ marginTop: 20 }}>
              <div style={{ marginRight: 20, marginTop: 20 }}>
                <Avatar
                  size={64}
                  style={{ backgroundColor: '#87d068' }}
                  icon={<UserOutlined />}
                  src={details?.['imageUrl']}
                />
              </div>
              <div style={{ flexGrow: 1 }}>
                <SGeneralForms
                  isDetail={true}
                  formConfig={{ form }}
                  configs={configs}
                ></SGeneralForms>
              </div>
            </Flex>
            <Tabs items={items}></Tabs>
          </Spin>
        </div>
      </div>
    </SBack>
  )
}

export default Details
